import { createSelector } from 'reselect';
import { extractGuid } from '@/utils';
import currentSessionIdSelector from './currentSessionId';

export default createSelector(currentSessionIdSelector, (sessionId) =>
  extractGuid(sessionId)
);
